import { projects } from '../types';

const INITIAL_STATE = {
    error: undefined
}

 const projectsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case projects.PROJECT_LIST_NAMES_SUCCESS:
            return {
                ...state,
                projectlist: action.payload
            }
        case projects.PROJECT_LIST_NAMES_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case projects.RESET_PROJECTS_STORE_SUCCESS:
            return INITIAL_STATE
        default:
            return state
    }
}

export default projectsreducer